// extracted by mini-css-extract-plugin
export default {"overlayLoader":"overlayLoader_overlayLoader__kH3XE"};